export class CustomerOrderList {
    private params: any = {};

    activate(params) {                
        this.params.Id = params.Id
    }
}